define('views/pages/checkout/CheckoutStepCrossSellingView',['underscore', 'jquery', 'app', 'moment',
        'views/pages/checkout/CheckoutStepView',
        'views/blocks/checkout/BaguettesReutilisablesDialogView',
        'views/blocks/CrossSellingView',
    ],
    function (_, $, app, moment,
              CheckoutStepView,
              BaguettesReutilisablesDialogView,
              CrossSellingView
              ) {

        var view, checkoutModel;

        return CheckoutStepView.extend({

            name:'cross_selling',
            events: {
            },
            beforeInitialize: function (model) {
                view = this;
                checkoutModel = model;
            },
            afterInitialize: function(checkoutModel){
                var _BAGUETTES_REUTILISABLES_WARN_ = app.warnBaguettesReutilisables(true);
                var _BAGUETTES_REUTILISABLES_WARN_DELAY_ = parseInt(app.c('_BAGUETTES_REUTILISABLES_WARN_DELAY_',10));
                var diff = moment().diff(localStorage.BAGUETTES_REUTILISABLES_WARN_DATE || 0,'d'); // délai en jours entre deux affichages
                if(_BAGUETTES_REUTILISABLES_WARN_ && diff > _BAGUETTES_REUTILISABLES_WARN_DELAY_){
                    setTimeout(function(){
                        new BaguettesReutilisablesDialogView();
                    },1000)
                }
            },

            render:function(){
                var view = this,
                    crossSellingView = new CrossSellingView();
                view.$el.append(crossSellingView.el);
                view.attachView(crossSellingView);
            },
        });
    });

